import React, { MouseEvent, useContext, useEffect, useMemo, useRef } from "react";
import { groupBy, makeLink } from "simple-utils";
import { ChannelTableView } from "../channels-page/channel-table-view";
import { Move2TopButton } from "../components/Move2TopButton";
import { Title } from "../components/Title";
import { Account } from "../models/Account";
import { TagStore } from "../tags/tag-context";
import { getRegion } from "../utils/state-utils";
import { BatchActions } from "./AccountBatchModal";
import { AccountItem, RegionBlock } from "./AccountComponents";
import { AccountContext, AccountStore } from "./AccountContext";
import { AccountDetail } from "./AccountDetail";
import AccountFilterBox from "./AccountFilter";
import { AccountTableView } from "./AccountTableView";
import { applyFilters } from "./filtering/filters";
import { useAccountSorter } from "./sorting/account-sorting";
import { WelcomeScreen } from "./WelcomeScreen";

export function AccountsPage(){
    return <TagStore><AccountStore>
        <AccountsIndex />
    </AccountStore></TagStore>
}



function AccountsIndex(){
    const {accounts, account, currentSorter, sorters, groupingOn, tableMode,  channelMode, filters, dispatch} = useContext(AccountContext);

    const sortedAccounts = useAccountSorter(accounts, currentSorter, sorters);
    const detailRef = useRef<HTMLDivElement>(null);

    const filteredAccounts = useMemo(() =>{
        if(sortedAccounts == null || sortedAccounts.length == 0) return [];
        
        let result = applyFilters(sortedAccounts, filters);
        dispatch({type: "setFiltered", payload: result});

        return result;

    }, [sortedAccounts, filters])
    
    const regions = useMemo(() => {
        if(accounts?.length == 0) return {};
        return groupBy(filteredAccounts, c => getRegion(c.state));
    }, [filteredAccounts]);

    useEffect(function(){
        if(!detailRef.current) return;
        if(!account) 
            return;
        detailRef.current.classList.remove("disappear")
        detailRef.current.classList.add("appear")
    }, [account]);

    function hideDetail(e:MouseEvent){
        if(!detailRef.current) return;
        if(e.target != detailRef.current)
            return;
        detailRef.current.classList.remove("appear")
        detailRef.current.classList.add("disappear")
    }

    useEffect(() => {
        if(!detailRef.current) return;
        detailRef.current.addEventListener("animationend", (e:any) => {
            if(e.srcElement != detailRef.current) 
                return;
            console.log(detailRef.current.className);
            if(detailRef.current.classList.contains("disappear")){
                console.log("hei");
                dispatch({type:"selectAccount", payload: null});
            }
        })
    }, []);

    if(channelMode)
        return <ChannelTableView accounts={filteredAccounts} />

    if(tableMode)
        return <AccountTableView accounts={filteredAccounts} />

    return (
        <>
          <BatchActions />  
          <div className="account-list-holder">
            <div className="p-3 px-2">
                <Title detailRef={detailRef} />
                <AccountFilterBox />    
                { groupingOn ?
                    Object.entries(regions).map(([region, accounts]) => <RegionBlock key={region} region={region} accounts={accounts} />) 
                    : <>
                        <p>Listando {filteredAccounts.length} contas.</p>
                        <div className="account-list">{filteredAccounts.map(a => <AccountItem  key={a.metaId}  account={a} />)}</div> 
                      </>}
             </div>
             <Move2TopButton scrollToElement=".account-list-holder > div" view="div.account-list-holder" />
          </div>
          <div className="detail-bg" ref={detailRef} onClick={hideDetail}>
             <div className="detail-div ">
                 <div className="p-3">
                    {account ? <AccountDetail /> : <WelcomeScreen /> }
                 </div>
             </div>
          </div>
    </>)

    /*return <div className="account-list" style={{padding: "0 10px"}}>
        {accounts.map(a => <AccountItem key={a.metaId} account={a} />)}
    </div>*/
}